// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let BOTTOM_WINDOWS_MARGIN = 32;
export let TOP_WINDOWS_MARGIN = 52;
export let WINDOW_SIDE_BORDERS_WIDTH = 4;